var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1225 -3428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.992,23.636,253.116.6a1.04,1.04,0,0,0-.941-.6H245.62l7.593,3.8a3.1,3.1,0,0,1,1.725,2.791V29.06l8.557-4.039a1.04,1.04,0,0,0,.5-1.385Z",
    transform: "translate(995.908 3428)",
    fill: "#0533b3",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1,
    cy: 1.5,
    rx: 1,
    ry: 1.5,
    transform: "translate(1235.835 3434.892)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2,5.573,12.339.1a1.012,1.012,0,0,0-.911,0L.563,5.573A1.026,1.026,0,0,0,0,6.49V33.97A1.022,1.022,0,0,0,1.019,35H22.748a1.022,1.022,0,0,0,1.019-1.025V6.49a1.026,1.026,0,0,0-.563-.917ZM12.76,28.215v1.157a.511.511,0,0,1-.509.513h-.944a.511.511,0,0,1-.509-.513V28.328A4.642,4.642,0,0,1,8.718,27.6a.515.515,0,0,1-.183-.591L8.9,26a.508.508,0,0,1,.762-.254,3.5,3.5,0,0,0,1.874.566c.762,0,1.274-.388,1.274-.966,0-.455-.234-.854-1.376-1.319-1.377-.547-2.79-1.337-2.79-3.085A2.9,2.9,0,0,1,10.9,18.1V16.988a.511.511,0,0,1,.509-.513h.929a.511.511,0,0,1,.509.513v.986a4.287,4.287,0,0,1,1.7.561.513.513,0,0,1,.219.623l-.374,1a.508.508,0,0,1-.729.263,3.108,3.108,0,0,0-1.635-.445c-1,0-1.079.6-1.079.784,0,.417.223.7,1.543,1.246,1.226.5,2.637,1.327,2.637,3.234a3.077,3.077,0,0,1-2.368,2.978Zm-.877-16.6a3.418,3.418,0,1,1,3.4-3.418,3.407,3.407,0,0,1-3.4,3.418Z",
    transform: "translate(1225 3428.004)",
    fill: "#0533b3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCost);
export default __webpack_public_path__ + "static/media/cost.2667d99412e7ce6d8725ba1a76642962.svg";
export { ForwardRef as ReactComponent };